import {
	ADMIN_NOTIFICATION_SET,
	ADMIN_NOTIFICATION_RESET_MESSAGE,
	ADMIN_NOTIFICATIONS_FETCH_REQUEST,
	ADMIN_NOTIFICATIONS_FETCH_FAILURE,
	ADMIN_NOTIFICATIONS_FETCH_SUCCESS,
	ADMIN_NOTIFICATION_FETCH_REQUEST,
	ADMIN_NOTIFICATION_FETCH_FAILURE,
	ADMIN_NOTIFICATION_FETCH_SUCCESS,
	ADMIN_NOTIFICATION_UPDATE_REQUEST,
	ADMIN_NOTIFICATION_UPDATE_FAILURE,
	ADMIN_NOTIFICATION_UPDATE_SUCCESS,
	ADMIN_NOTIFICATION_CREATE_REQUEST,
	ADMIN_NOTIFICATION_CREATE_FAILURE,
	ADMIN_NOTIFICATION_CREATE_SUCCESS,
	ADMIN_NOTIFICATION_DELETE_REQUEST,
	ADMIN_NOTIFICATION_DELETE_FAILURE,
	ADMIN_NOTIFICATION_DELETE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function adminNotifications(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case ADMIN_NOTIFICATION_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case ADMIN_NOTIFICATION_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case ADMIN_NOTIFICATIONS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case ADMIN_NOTIFICATIONS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case ADMIN_NOTIFICATIONS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		case ADMIN_NOTIFICATION_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				selected: false,
				message: {
					type: '',
					text: '',
				},
			};

		case ADMIN_NOTIFICATION_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case ADMIN_NOTIFICATION_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				selected: Number(payload.notification),
				message: {
					type: 'success',
					text: '',
				},
			};

		case ADMIN_NOTIFICATION_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case ADMIN_NOTIFICATION_UPDATE_FAILURE:
			return {
				...state,
				message: {
					type: 'error',
					text: payload.message,
				},
				isUpdating: false,
			};
		case ADMIN_NOTIFICATION_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case ADMIN_NOTIFICATION_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case ADMIN_NOTIFICATION_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case ADMIN_NOTIFICATION_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case ADMIN_NOTIFICATION_DELETE_REQUEST:
			return {
				...state,
				isDeleting: true,
				message: {
					type: '',
					text: '',
				},
			};

		case ADMIN_NOTIFICATION_DELETE_FAILURE:
			return {
				...state,
				isDeleting: true,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case ADMIN_NOTIFICATION_DELETE_SUCCESS:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/adminNotifications.js